export default __webpack_public_path__ + "static/media/video.3e305810.svg";